import { Box } from '@nimbus-ds/components';
import { TotalsInterface } from 'domains/Statistics/types';
import SummaryItemCard, { SummaryItemCardProps } from '../../SummaryItemCard';

export interface SummaryListProps<TKeys extends string>
  extends Pick<SummaryItemCardProps<TKeys>, 'onChange' | 'formatValue'> {
  colors: Record<TKeys, string>;
  totals: Record<TKeys, TotalsInterface>;
  showValues: boolean;
  selecteds: string[];
  dataHasComparison: boolean;
  isMaxSelected: boolean;
  formatSummaryTitle: (key: TKeys) => string;
  formatSummaryTooltip: (key: TKeys) => string;
}

function SummaryList<TKeys extends string>({
  totals,
  onChange,
  selecteds,
  dataHasComparison,
  isMaxSelected,
  colors,
  showValues,
  formatValue,
  formatSummaryTitle,
  formatSummaryTooltip,
}: SummaryListProps<TKeys>) {
  return (
    <Box
      display="grid"
      gridGap="4"
      paddingLeft="4"
      paddingRight="4"
      paddingBottom="4"
    >
      {Object.keys(colors).map((key) => {
        const item = key as TKeys;
        return (
          <SummaryItemCard<TKeys>
            key={item}
            formatValue={formatValue}
            name={item}
            color={colors[item]}
            showValues={showValues}
            onChange={onChange}
            isSelected={selecteds.includes(item)}
            title={formatSummaryTitle(item)}
            value={totals[item].value}
            percentageDiff={
              dataHasComparison ? totals[item].percentageDiff : undefined
            }
            disabled={!selecteds.includes(item) && isMaxSelected}
            itemMode={dataHasComparison ? 'radio' : 'toggle'}
            textTooltip={formatSummaryTooltip(item)}
          />
        );
      })}
    </Box>
  );
}

export default SummaryList;
